import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Collect = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "m14 8.25v-6.25h29.18l13.12 13.12v40.63h-6.3v6.25h-42.3v-53.75zm30-1.35v7.38h7.4zm9.41 10.25h-12.26v-12.28h-24.32v48h36.6zm-42.86 42h36.6v-3.4h-33.15v-44.62h-3.43z" }), _jsx("path", { d: "m47.41 30.74h-10.61v-10.61h-3.35v10.61h-10.61v3.35h10.61v10.61h3.35v-10.61h10.61z" })] })));
Collect.iconName = "collect";
Collect.iconCategory = "Misc - Deprecated";
Collect.deprecated = true;
export default Collect;
